<script>
import { mapState } from "vuex";

import scrollMixin from "@/mixins/scrollMixin";

import Tooltip from "@/components/_Shared/Tooltip";

export default {
  mixins: [scrollMixin],

  components: {
    Tooltip
  },

  data() {
    return {
      selectedCard: null,
      cvv: "012"
    };
  },

  methods: {
    selectCard(id) {
      const previousCard = this.selectedCard;

      this.selectedCard = null;
      this.$emit("updateCanPay", false);

      if (previousCard != id) {
        this.selectedCard = id;
        this.$emit("updateCanPay", true);
        this.$store.commit("payable/SET_PAYMENT_DATA", this.$data);
      }
    },

    isSelectedCard(id) {
      return this.selectedCard === id;
    },

    defaultCardName(card) {
      return `${card.brand[0]}${card.brand.slice(1).toLowerCase()}`;
    }
  },

  computed: {
    ...mapState("payable", ["creditCards"])
  },

  mounted() {
    this.scrollTo("#stored-credit-card");
  }
};
</script>

<template>
  <div id="stored-credit-card" class="stored-credit-cards">
    <div class="credit-cards">
      <div class="credit-card" v-for="card in creditCards" :key="card.id">
        <div class="left" :class="{ 'left-selected': isSelectedCard(card.id) }" @click="selectCard(card.id)">
          <div class="card-info">
            <img class="card-logo" :src="`/static/credit-card/${card.brand.toLowerCase()}.svg`"/>

            <div class="card-identifier">
              <span class="card-name">
                {{ card.name || defaultCardName(card) }} · Crédito
              </span>

              <span class="card-number"><b>····</b>  {{ card.last4 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.stored-credit-cards {
  width: 100%;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header-text {
  margin-bottom: 12px;
  font-size: 12px;
  color: #603285;
}

.credit-cards {
  width: 100%;
}

.credit-card {
  width: 100%;
  max-width: 400px;
  display: flex;
  margin: 0 auto;
}

.credit-card-selected {
  max-width: 480px;
}

.credit-card:not(:last-child) {
  margin-bottom: 16px;
}

.left {
  width: calc(100% - 32px);
  height: 45px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e2e2e2;
  border-radius: 4px;
  opacity: 0.75;
}

.right {
  margin-left: 12px;
}

.right-disabled {
  display: none;
}

.card-info {
  width: calc(100% - 25px);
  display: flex;
  align-items: center;
}

.left-selected {
  border: solid 2px #603285;
}

.card-logo {
  width: 40px;
  max-height: 40px;
  margin-right: 16px;
}

.card-identifier {
  width: calc(100% - 56px);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.card-identifier span {
  font-size: 12px;
}

.card-name {
  width: calc(100% - 16px);
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #424242;
  font-weight: 500;
}

.card-number {
  font-weight: 400;
  white-space: break-spaces;
}

.arrow {
  width: 25px;
  height: 25px;
}

.field span {
  color: #333;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
}
.field input {
  width: calc(100% - 16px - 2px);
  height: 36px;
  margin-top: 4px;
  border-radius: 4px;
  border: solid 1px #e2e2e2;
  padding: 0 8px;
  transition: all 0.25s ease;
}

.field input:focus {
  border-color: var(--pink);
}

.field.has-error input {
  border: 1px solid var(--red);
}

.field.has-error span {
  color: var(--red);
}

.tooltip-position {
  position: relative;
  top: 12px;
  right: 5px;
}

.empty {
  padding: 16px 0;
}

@media (max-width: 400px) {
  .hide-card-name {
    display: none;
  }
}

@media (max-width: 450px) {
  .left-selected .card-name {
    max-width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payment/PaymentOptions/StoredCreditCard.vue